<template>
  <div class="flex items-start gap-12">
    <div class="bg-static-info-mid rounded-lg flex items-center p-8">
      <component :is="icon" />
    </div>
    <div class="space-y-4">
      <div class="text-static-default-hi body-1-bold">
        {{ title }}
      </div>
      <div class="text-static-default-low body-2">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  icon: Component
  title: string
}>()
</script>
